import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { FocusTrap as FocusTrap$1 } from 'focus-trap-react';
import { TrapChild } from './components/TrapChild.js';

var FocusTrap = (_param)=> {
    var { children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "children"
    ]);
    return React.createElement(FocusTrap$1, swcHelpers.extends({}, rest), /*#__PURE__*/ React.createElement(TrapChild, null, children));
};

export { FocusTrap, FocusTrap as default };
//# sourceMappingURL=FocusTrap.js.map
